import apiConfig from '../../config/api_config';

export const courseApi = {
    getCourse: (courseId) => 
        apiConfig.get(`/courses/${courseId}`),
    
    checkEnrollment: (courseId) => 
        apiConfig.get(`/courses/${courseId}/enrollment`),
    
    enrollInCourse: (courseId) => 
        apiConfig.post(`/courses/${courseId}/enroll`),
    
    updateProgress: (data) => 
        apiConfig.post('/courses/progress', data),
    
    getAllCourses: () => 
        apiConfig.get('/courses'),
};